import React, { useContext } from "react"
import { Link as GatsbyLink, navigate } from "gatsby"
import { UserInterfaceContext } from "../context/UserInterfaceContext"
import { fixBlogUrl } from "./local-menu"
import redirects from "../data/redirects.json"

interface ILinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  children: React.ReactNode
  to: string
  activeClassName?: string
  partiallyActive?: boolean
  external?: boolean
}

interface IPathReplacement {
  from: string | RegExp
  to: string
}
export function replacePaths(path: string): string {
  const paths = [
    {
      from: `/news-events/all-events/`,
      to: `/events/`,
    },
    {
      from: `/academics/part-time-studies/certificates-and-programs/`,
      to: `/academics/part-time-studies/programs/`,
    },
    {
      from: `/academics/part-time-studies/search-results/?type=certificates_programs`,
      to: `/academics/part-time-studies/programs/`,
    },
    {
      from: `/academics/part-time-studies/search-results/?area=Professional+Development&study=&campus=`,
      to: `/academics/part-time-studies/courses/?area=PDEV`,
    },
    {
      from: `/academics/part-time-studies/search-results/?area=Life+and+Leisure&study=&campus=`,
      to: `/academics/part-time-studies/courses/?area=LLEI`,
    },
    {
      from: `/academics/part-time-studies/search-results/courses/`,
      to: `/academics/part-time-studies/courses/`,
    },
    {
      from: `/academics/part-time-studies/search-results/?type=professional_development&area=Ontario%20Learn%20(Online)`,
      to: `/academics/part-time-studies/courses/?area=ONTL`,
    },
    {
      from: `/academics/part-time-studies/search-results/?type=professional_development&area=Ontario Learn (Online)`,
      to: `/academics/part-time-studies/courses/?area=ONTL`,
    },
    {
      from: `/academics/part-time-studies/search-results/?area=Ontario%20Learn%20(Online)`,
      to: `/academics/part-time-studies/courses/?area=ONTL`,
    },
    {
      from: `/academics/part-time-studies/search-results/?area=Ontario Learn (Online)`,
      to: `/academics/part-time-studies/courses/?area=ONTL`,
    },
    {
      from: `/academics/part-time-studies/courses/?area=Ontario%20Learn%20(Online)`,
      to: `/academics/part-time-studies/courses/?area=ONTL`,
    },
    {
      from: `/academics/part-time-studies/courses/?area=Ontario Learn (Online)`,
      to: `/academics/part-time-studies/courses/?area=ONTL`,
    },
    {
      from: /\/academics\/part-time-studies\/courses\/(.*)/,
      to: `/academics/courses/$1`,
    },
  ]
  const replacement = paths.find((p: IPathReplacement) => {
    if (typeof p.from === `string`) {
      return path === p.from
    }
    return p.from.test(path)
  })
  if (replacement) {
    return path.replace(replacement.from, replacement.to)
  }
  return path
}

// Since DOM elements <a> cannot receive activeClassName
// and partiallyActive, destructure the prop here and
// pass it only to GatsbyLink
const Link = ({
  children,
  to,
  activeClassName,
  partiallyActive,
  external = false,
  target,
  ...other
}: ILinkProps): JSX.Element => {
  // Tailor the following test to your environment.
  // This example assumes that any internal link (intended for Gatsby)
  // will start with exactly one slash, and that anything else is external.
  const {
    setShowMainContentWithSideEffects,
    setMegaMenuActive,
    setMobileMenuOpen,
    setActivePageTab,
  } = useContext(UserInterfaceContext)

  const internal = /^\/(?!\/)/.test(to)

  // link is to a tab
  let tab: string | null = null
  if (typeof window !== `undefined` && internal && to.includes(`#tab/`)) {
    const split = to.split(`#tab/`)
    // if the path is the same as the current path and has a tab id, set the tab
    if (split.length > 1 && window.location.href.includes(split[0]))
      tab = split[1]
  }

  const redirectPaths = redirects.map(r => r.fromPath)

  if (
    redirectPaths.includes(to) || // if path has a redirect new tab it
    to.slice(-5, -4) === `.` || // ends with a 4 char file extension, ie: .docx
    to.slice(-4, -3) === `.` || // ends with a 3 char file extension, ie: .pdf, .png, etc
    target === `_blank`
  )
    external = true // open files in new tab

  // Use Gatsby Link for internal links, and <a> for others
  if (internal && !external) {
    // ensure last character of to is a slash if there is no querystring
    if (
      !to.includes(`?`) && // no trailing slash if there is a querystring
      !to.includes(`#`) && // no trailing slash if there is a hash
      to.slice(-1) !== `/` // no trailing slash if there is already one
    ) {
      to = `${to}/`
    }
    to = replacePaths(fixBlogUrl(to))
    return (
      <GatsbyLink
        onClick={(e): void => {
          e.preventDefault()

          // console.log(e)
          setMobileMenuOpen(false)
          setMegaMenuActive(``)
          setShowMainContentWithSideEffects(false)
          window.setTimeout(() => {
            // setShowMainContent(true)
            navigate(to)
            if (tab !== null) {
              setActivePageTab(tab)
            }
          }, 50)
        }}
        to={to}
        activeClassName={activeClassName}
        partiallyActive={partiallyActive}
        {...other}
      >
        {children}
      </GatsbyLink>
    )
  }
  return (
    <a href={to} {...other} target={external ? `_blank` : undefined}>
      {children}
    </a>
  )
}

export default Link
